<script setup lang="ts">
import { ref, onMounted } from "vue";
import SearchSelect from "../../../../components/ui/form/SearchSelect.vue";
import { useFormValidation } from "../../../../composables/useFormValidation";
import { api } from "../../../../api/Api";
import Toast from "../../../../services/Toast";
import { required } from "../../../../utils/validation";
import ModalFormComponent from "../../../../components/ui/common/ModalFormComponent.vue";
import DocumentHeader from "../../../../components/ui/Templates/DocumentHeader.vue";
import DocumentFooter from "../../../../components/ui/Templates/DocumentFooter.vue";
import Buttons from "../../../../components/ui/form/Buttons.vue";
import FileUpload from "../../../../components/ui/form/FileUpload.vue";
import * as XLSX from "xlsx";
import { TableField } from "../../../../components/table/table";

const props = defineProps<{
  endPoint: string;
}>();

const emit = defineEmits<{
  (e: "save"): void;
  (e: "close"): void;
}>();



interface matchField {
  field_name: string;
  caption: string;
  requried: boolean;
  mapped?: string;
}

interface excelFields {
  id: string;
  name: string;
}

const {
  setFieldRules,
} = useFormValidation({
  price_lists_id: "",
  warehouses_id: "",
  currencys_id: "",
  exchange_rate: 1,
});
setFieldRules("price_lists_id", [required("Select Price List")]);
setFieldRules("warehouses_id", [required("Select Warehouse")]);
setFieldRules("currencys_id", [required("Select Currency")]);
setFieldRules("exchange_rate", [required("Select Exchange Rate")]);

const matchFields = ref<matchField[]>([
  { field_name: "item_category", caption: "Category", requried: true, mapped: "" },
  { field_name: "parent_category", caption: "Parent Category", requried: false, mapped: "" },
  { field_name: "item_group", caption: "Item Group", requried: true, mapped: "" },
]);

const tableColumns = ref<TableField[]>([]);

const excelData = ref<any[][]>([]);
const colHeaders = ref<excelFields[]>([]);

const handleFileUpload = (files: any[]) => {
  console.log(files);
  const file = files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (e) => {
    if (e.target && e.target.result) {
      const data = new Uint8Array(e.target.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0]; // Get the first sheet name
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 }); // Convert sheet to JSON
      if (jsonData.length > 0) {
        const arr = (jsonData[0] as string[]).map(
          (text: string, index: number) => ({
            id: index.toString(),
            name: text,
          })
        );
        arr.forEach((element) => {
          colHeaders.value.push(element);
          tableColumns.value.push({
            name: element.name,
            caption: element.name,
            sortable: false,
            fieldType: "text",
          });
        });
        jsonData.splice(0, 1); // Remove the first row from data

        excelData.value = jsonData as any[][];
      }
    }
  };
  reader.readAsArrayBuffer(file);
};

const mappedData = ref<Array<{
  category: string;
  parent_category: string;
  item_group: string;
}>>([]);

const validated = ref(false);
const handleValidate = () => {
  let valid = true;
  excelData.value.forEach((row, index) => {
    console.log('row', row)
    const element = {
      item_category: matchFields.value.find((field) => field.field_name === "item_category")?.mapped
        ? row[Number(matchFields.value.find((field) => field.field_name === "item_category")?.mapped)]
        : "",
      item_group: matchFields.value.find((field) => field.field_name === "item_group")?.mapped
        ? row[Number(matchFields.value.find((field) => field.field_name === "item_group")?.mapped)]
        : "",
    };

    console.log("element", element);
    if (element.item_category === "") {
      valid = false;
      console.log("valid1", valid);
      return false;
    }
    if (element.item_group === "") {
      valid = false;
      console.log("valid2", valid);
      return false;
    }

    if (index == excelData.value.length - 1) {
        console.log("valid3", valid);
      validated.value = valid;
    }

  });
};


const handleImportPost = async () => {

    const row = excelData.value[importIndex.value]; 
    const element = {
      item_category: matchFields.value.find((field) => field.field_name === "item_category")?.mapped
        ? row[Number(matchFields.value.find((field) => field.field_name === "item_category")?.mapped)]
        : "",
      item_group: matchFields.value.find((field) => field.field_name === "item_group")?.mapped
        ? row[Number(matchFields.value.find((field) => field.field_name === "item_group")?.mapped)]
        : "",
    parent_category: matchFields.value.find((field) => field.field_name === "parent_category")?.mapped
        ? row[Number(matchFields.value.find((field) => field.field_name === "parent_category")?.mapped)]
        : "",
    };

  await api.post(
        (props.endPoint.slice(-1) == "/"
          ? props.endPoint
          : props.endPoint + "/") + "import",
          element
      ).then((response) => {
        if (response.success == true) {
          Toast.show(
            "Importing record " +
              (importIndex.value + 1) +
              " of " +
              excelData.value.length +
              " records",
            "info"
          );
          if (importIndex.value < excelData.value.length - 1) {
            importIndex.value++;
            handleImportPost();
          } else {
            Toast.show("All records imported successfully", "info");
            emit('save');
            validated.value = false;
            mappedData.value = [];
          }
        } else {
          Toast.show(
            "Error importing record " +
              (importIndex.value + 1) +
              " of " +
              excelData.value.length +
              " records",
            "error"
          );
        }
      })
      .catch((() => {
        Toast.show(
          "Error importing record " +
            (importIndex.value + 1) +
            " of " +
            excelData.value.length +
            " records",
          "error"
        );
      }));
};


const importIndex = ref(0);
const handleImport = async () => {
 
  /*if (excelData.value.filter((record) => getBgColor(record) != "").length > 0) {
    MessageBox.show(
      "Please fix all invalid records before importing.",
      "error"
    );
    return;
  } else {
  console.log('start posting', excelData.value[0]);
  importIndex.value = 0;
  handleImportPost()
  }*/

  importIndex.value = 0;
  handleImportPost()

};

onMounted(() => {});

</script>

<template>
  <ModalFormComponent width="40rem" :fullscreen="false" @close="$emit('close')">
    <template #header>
      <!-- Header -->
      <DocumentHeader
        title="Import Sales using Excel Files"
        end-point=""
        :readonly="true"
        :show-drop-down="false"
        @close="$emit('close')"
        :permissions="[]"
        :show-share-icons="false"
        :show-save-icon="false"
      >
        <template>
        </template>
      </DocumentHeader>
    </template>

    <template #form>
      <div class="grid grid-cols-4 gap-6 mb-8">
        <div>
          <FileUpload
            label="Excel File"
            accept=".xlsx, .xls"
            @upload-success="handleFileUpload"
            path=""
            :local="true"
          />
            <Buttons
              caption="Validate"
              icon="ShieldCheck"
              v-if="excelData.length > 0"
              @click="handleValidate"
              className="mt-2"
            />

            <Buttons
              caption="Import"
              icon="Import"
              class="col-span-2"
              type="info"
              v-if="validated"
              @click="handleImport"
              className="mt-2"
            />
        </div>
        <div class="col-span-3 grid grid-cols-3 gap-1">
          <div v-for="(field, index) in matchFields" :key="index">
            <SearchSelect
              :label="field.caption"
              :options="colHeaders"
              :multiple="false"
              :placeholder="'Select Excel Fields'"
              v-model="field.mapped"
            />
          </div>
        </div>
      </div>
      <div>
        <table
          class="divide-y divide-gray-200 dark:divide-gray-700"
          id="table-records"
        >
          <thead>
            <tr id="table-headers">
              <th
                class="px-6 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                v-for="h in colHeaders"
              >
                {{ h.name }}
              </th>
            </tr>
          </thead>
          <tbody
            class="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700"
          >
            <template v-for="(row) in excelData">
              <tr class="hover:bg-gray dark:hover:bg-gray-700">
                <td
                  class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white"
                  v-for="(cell, cellIndex) in row"
                  :key="cellIndex"
                >
                  {{ cell }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </template>

    <!-- Footer -->
    <template #footer>
      <DocumentFooter
        :readonly="true"
        end-point="endPoint"
        :permissions="[]"
        title="Import Sales using Excel Files"
        @close="$emit('close')"
        :show-new-icon="false"
        :show-share-icons="false"
        :show-save-icon="false"
      />
    </template>
  </ModalFormComponent>
</template>
